(function () {
  var root = document.querySelector('[data-quick-view-root]');

  if (!root) {
    return;
  }

  var dialog = root.querySelector('[data-quick-view-dialog]');
  var content = root.querySelector('[data-quick-view-content]');
  var loading = root.querySelector('[data-quick-view-loading]');
  var fetchLoading = root.querySelector('[data-quick-view-fetch-loading]');
  var activeHandle = '';
  var lastTrigger = null;
  var closeTimer = null;
  var CLOSE_DURATION = 300;

  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function setLoading(isLoading) {
    if (!loading) {
      return;
    }

    loading.hidden = !isLoading;
  }

  function setFetchLoading(isLoading) {
    if (!fetchLoading) {
      return;
    }

    fetchLoading.hidden = !isLoading;
  }

  function lockBody(isLocked) {
    document.documentElement.classList.toggle('quick-view-open', isLocked);
  }

  function focusQuickViewPrimary() {
    var closeButton = root.querySelector('.quick-view__dialog [data-quick-view-close]');

    if (closeButton && typeof closeButton.focus === 'function') {
      closeButton.focus({ preventScroll: true });
    }
  }

  function revealQuickView() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        root.classList.remove('is-loading');
        root.classList.add('is-open');
      });
    });
  }

  function initQuickViewContent(scope) {
    scope.querySelectorAll('[data-quick-view-handle]').forEach(function (button) {
      if (button.dataset.quickViewBound === 'true') {
        return;
      }

      button.addEventListener('click', function () {
        var handle = button.getAttribute('data-quick-view-handle');

        if (handle && handle !== activeHandle) {
          openQuickView(handle);
        }
      });

      button.dataset.quickViewBound = 'true';
    });

    if (typeof window.initProductInfo === 'function') {
      window.initProductInfo(scope);
    }

    if (typeof window.bindAjaxCartForms === 'function') {
      window.bindAjaxCartForms(scope);
    }
  }

  function finishClose() {
    if (!root.classList.contains('is-closing')) {
      return;
    }

    root.classList.remove('is-closing', 'is-loading');
    root.setAttribute('hidden', 'hidden');
    content.innerHTML = '';
    activeHandle = '';
    setFetchLoading(false);
    setLoading(false);

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function forceResetQuickView() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    root.classList.remove('is-open', 'is-loading', 'is-closing');
    root.setAttribute('hidden', 'hidden');
    root.setAttribute('aria-hidden', 'true');
    lockBody(false);
    setFetchLoading(false);
    setLoading(false);
    content.innerHTML = '';
    activeHandle = '';
  }

  function closeQuickView() {
    if (root.classList.contains('is-closing')) {
      return;
    }

    if (!root.classList.contains('is-open') && !root.classList.contains('is-loading')) {
      return;
    }

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    root.classList.remove('is-open', 'is-loading');
    root.classList.add('is-closing');
    root.setAttribute('aria-hidden', 'true');
    lockBody(false);
    setFetchLoading(false);
    setLoading(false);

    closeTimer = window.setTimeout(function () {
      closeTimer = null;
      finishClose();
    }, CLOSE_DURATION);
  }

  function openQuickView(handle, trigger) {
    if (!handle) {
      return;
    }

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
      root.classList.remove('is-closing');
    }

    var isAlreadyOpen = root.classList.contains('is-open');
    lastTrigger = trigger || lastTrigger;
    activeHandle = handle;

    if (isAlreadyOpen) {
      setLoading(true);
    } else {
      root.removeAttribute('hidden');
      root.classList.remove('is-closing', 'is-open');
      root.setAttribute('aria-hidden', 'false');
      lockBody(true);
      setFetchLoading(true);
      content.innerHTML = '';
      root.classList.add('is-loading');
    }

    var url = getRoutesRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=quick-view';

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Quick view failed');
        }

        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');

        content.innerHTML = section ? section.innerHTML : html;
        initQuickViewContent(content);
        document.dispatchEvent(new CustomEvent('quick-view:loaded'));

        if (typeof window.initRenkVaryantSwatches === 'function') {
          try {
            window.initRenkVaryantSwatches();
          } catch (error) {}
        }

        if (isAlreadyOpen) {
          focusQuickViewPrimary();
          return;
        }

        setFetchLoading(false);
        revealQuickView();

        window.setTimeout(function () {
          focusQuickViewPrimary();
        }, CLOSE_DURATION);
      })
      .catch(function () {
        if (root.classList.contains('is-open') || root.classList.contains('is-loading')) {
          closeQuickView();
        } else {
          forceResetQuickView();
        }

        window.location.href = getRoutesRoot() + 'products/' + encodeURIComponent(handle);
      })
      .finally(function () {
        setLoading(false);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view-trigger][data-product-handle]');

    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openQuickView(trigger.getAttribute('data-product-handle'), trigger);
      return;
    }

    if (event.target.closest('[data-quick-view-close]')) {
      event.preventDefault();
      closeQuickView();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && (root.classList.contains('is-open') || root.classList.contains('is-loading'))) {
      closeQuickView();
    }
  });

  window.openQuickView = openQuickView;
  window.closeQuickView = closeQuickView;
  window.initQuickViewContent = initQuickViewContent;
})();
